<template>
	<div id="app">
		
    <div id="nav" class="is-black">
      <a href="" @click.prevent="toggleMusic" class="is-text-white is-pulled-left"> 
        <i class="fas fa-volume-down"></i>
      </a>&nbsp;
			<router-link to="/">HOME</router-link> |
			<router-link to="/about">BIO</router-link>
		</div>
		<router-view />
    <div v-show="false">
    <youtube
      width="100%"
      :playing="playing"
      :video-id="'lFzVpgzTJGU'"
      ref="youtube"
      :player-vars="{ autoplay: 1 }"
    ></youtube>
    </div>
	</div>
</template>
<script>
  export default {
    data(){
      return {
        playing: true 
      }
    },
    methods: {
      toggleMusic(){
        if(this.playing)
          this.$refs.youtube.player.stopVideo()
        else this.$refs.youtube.player.playVideo()
        
        this.playing = !this.playing
      }
    }
  }
</script>
<style lang="scss">
@import "https://cdn.jsdelivr.net/npm/bulma@0.8.0/css/bulma.min.css";
#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
}

#nav {
	padding: 30px;

	a {
		font-weight: bold;
		color: #2c3e50;

		&.router-link-exact-active {
			color: #42b983;
		}
	}
}
body {
	font-family: "Quicksand";
	background-color: black;
}
#main {
	background-image: url("assets/img/14087214_10210488165667168_222789327_o.jpg");
	background-size: cover;
}
#media {
	background-image: url("assets/img/vynils.jpg");
	background-size: cover;
}
#about {
	background-image: url("assets/img/vn.jpg");
	background-size: cover;
}

#news {
	background-image: url("assets/img/news.jpg");
	background-size: cover;
	background-repeat: no-repeat;
}

#media {
	/* background-image: url('img/vynil.jpg');
    background-size: cover;
    background-repeat: no-repeat; */
}
.reds {
	background: red;
}

a {
	color: white;
}
#scroll_to {
	position: fixed;
	right: 10px;
	bottom: 10px;
	background: rgba(0, 0, 0, 0.6);
	color: white;
	padding: 10px;
}
.slide {
	background: black;
}
</style>
